import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-core',
  templateUrl: './core.component.html',
  styleUrls: ['./core.component.scss']
})
export class CoreComponent implements OnInit, OnDestroy {

  constructor(
    private subject: SubjectService,
    private router: Router,
    private auth: AuthService
  ) { }

  accessSubcription: Subscription;

  isLoggedin = false;

  ngOnInit(): void {
    this.checkAccess();

    this.accessSubcription = this.subject.getAccessSubject().subscribe(access => {
      this.isLoggedin = access;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart && event.url.includes('login')) {
        this.isLoggedin = false;
        this.auth.logout();
        window.localStorage.clear();
      } else if (event instanceof NavigationStart) {
        this.checkAccess();
      }
    });
  }

  checkAccess(): void {
    if (this.auth.isLoggedIn()) {
      this.isLoggedin = true;
    } else {
      this.router.navigate(['login']);
    }
  }

  ngOnDestroy(): void {
    this.accessSubcription.unsubscribe();
  }

}
